import { createSvgIcon } from '@mui/material';
import { ReactNode } from 'react';

const svg: ReactNode = (
  <path
    d="M22 21.867H2C2 18.778 2.26 18.908 3.02 18.328C3.78 17.738 5.85 17.038 7.59 16.269C9.34 15.489 9.61 14.3 9.66 13.57C9.7 12.84 9.38 12.58 9.03 12.12C8.67 11.65 8.53 11.15 8.47 10.73C8.4 10.3 8.2 10.23 8.06 10.15C7.93 10.07 7.63 10.06 7.43 9.15003C7.24 8.25003 7.79 7.82103 7.79 7.82103C7.79 7.82103 7.57 6.58103 7.56 5.88203C7.55 5.18203 7.89 4.22303 7.89 4.22303C8.54 2.22403 11.33 2.13403 11.84 2.13403H12.16C12.67 2.13403 15.46 2.22403 16.11 4.22303C16.11 4.22303 16.45 5.18303 16.44 5.88203C16.43 6.58103 16.21 7.82103 16.21 7.82103C16.21 7.82103 16.76 8.25103 16.57 9.15003C16.37 10.06 16.07 10.07 15.94 10.15C15.8 10.23 15.6 10.3 15.53 10.73C15.47 11.15 15.33 11.65 14.97 12.12C14.62 12.58 14.3 12.84 14.34 13.57C14.39 14.3 14.66 15.489 16.41 16.269C18.15 17.039 20.22 17.739 20.98 18.328C21.74 18.908 22 18.778 22 21.867V21.867Z"
    fill="currentColor"
  />
);

const Icon = createSvgIcon(svg, 'PersonFill');

export default Icon;
